<template>
  <div>
    <draggable-table>
      <el-table :show-header="false" class="table" :data="data" stripe>
        <el-table-column>
          <template slot-scope="scope">
            {{ scope.row }}
          </template>
        </el-table-column>

        <el-table-column width="40" align="center">
          <template>
            <i class="el-icon-rank"></i>
          </template>
        </el-table-column>

        <el-table-column width="40" align="center">
          <template slot-scope="scope">
            <i class="el-icon-delete" @click="deleteAttr(scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
    </draggable-table>

    <el-button
      class="m-top-20"
      icon="el-icon-circle-plus-outline"
      type="primary"
      :disabled="availableFields.length === 0"
      plain
      @click="showSelect()"
    >
      {{ $t('Automations_Title_Fields_Add_Button') }}
    </el-button>

    <el-select
      v-show="selectVisible"
      v-model="newAttr"
      ref="select"
      @visible-change="selectVisibleChange"
      @change="addAttr"
      :loading="selectLoading"
      :placeholder="$t('Automations_Title_Fields_Dropdown_Placeholder')"
      filterable
    >
      <el-option
        v-for="(item, index) in availableFields"
        :key="index"
        :label="item"
        :value="item"
      />
    </el-select>
  </div>
</template>

<script>
import DraggableTable from '@/common/components/table/DraggableTable'
import _ from 'lodash'

export default {
  name: 'ExportFieldsListDraggable',

  components: { DraggableTable },

  props: {
    value: {
      required: true
    }
  },

  data() {
    return {
      data: [],
      attributes: [],
      attributesPages: null,
      newAttr: null,
      selectVisible: false,
      selectLoading: false,
      allFields: [
        'campaign_name',
        'category_id',
        'category_name',
        'user_id',
        'profile_id',
        'device_id',
        'message_type',
        'message_variant',
        'message_variant_name',
        'language_variant',
        'campaign_schedule_type',
        'email',
        'email_from_name',
        'email_subject',
        'mobile_number',
        'sms_from_name',
        'push_title',
        'interaction_type',
        'interaction_value',
        'workflow_action_id',
        'workflow_action_name',
        'timestamp',
        'interaction_id',
        'trigger_id',
        'external_message_id',
        'labels',
        'bonus_id'
      ],
      search: ''
    }
  },

  created() {
    this.data = this.value
    if (this.data === null) {
      this.data = _.clone(this.allFields)
    }
  },

  computed: {
    availableFields() {
      return this.fields.filter(opt => !this.data.includes(opt))
    },

    fields() {
      let allFields = this.allFields
      if (this.search === '') {
        return allFields
      } else {
        return allFields.filter(e => e.includes(this.search))
      }
    }
  },

  methods: {
    showSelect() {
      this.search = ''
      this.selectVisible = true
      setTimeout(() => {
        this.$refs['select'].focus()
      }, 0)
    },

    selectVisibleChange(visible) {
      if (!visible) {
        this.selectVisible = false
      }
    },

    addAttr(attr) {
      this.data.push(attr)
      this.newAttr = null
    },

    deleteAttr(index) {
      this.data.splice(index, 1)
    }
  },

  watch: {
    data: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-table {
  border-radius: 4px;
  border: 1px solid #dbdee7;
}

/deep/ .el-select input {
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/modules/automations/components/ExportFieldsListDraggable.vue